const URL = '/api/v1/eye_care_providers/near';

const settings = {
  credentials: 'same-origin',
};

class EyeCareProvidersService {
  static getNear ({ latitude, longitude, distanceLimit }) {
    const url = `${URL}?latitude=${latitude}&longitude=${longitude}&distance=${distanceLimit}`;
    return fetch(url, settings);
  }
}

export default EyeCareProvidersService;
